import React, {Component} from 'react';
import {connect} from 'react-redux';
import LabelTranslationEditContent from '../forms/EditLabelTranslationForm';
import {
    fetchLabelTranslation,
    updateLabelTranslation
} from '../thunks';

class LabelTranslationEdit extends Component {

    handleEditTranslationSubmit(formProps) {
        this.props.updateLabelTranslation(
            formProps,
            this.props.label.id,
            this.props.labelTranslation.id
        );
    }

    getSiteName(options) {
        let siteId = this.props.labelTranslation.site_id;
        let name = options.map(element => {
            if(siteId === element.id) {
                return element.display_name;
            }
            return false;
        });

        return name;
    }

    render() {
        return (
            this.props.loading !== true &&
            <LabelTranslationEditContent
                label={this.props.label}
                classes={this.props.classes}
                loading={this.props.loading}
                siteName={this.getSiteName(this.props.sites)}
                initialValues={this.props.initialValues}
                handleFormSubmit={this.handleEditTranslationSubmit.bind(this)}
            />
        )
    }
}

const mapStateToProps = (state, props) => ({
    initialValues: {
        display_name: state.labels.labelTranslation.display_name,
        site_id: state.labels.labelTranslation.site_id
    },
    labelTranslation: state.labels.labelTranslation,
    loading: state.layout.ajaxCallsInProgress > 0,
});

export default connect(mapStateToProps, {
    fetchLabelTranslation,
    updateLabelTranslation
})(LabelTranslationEdit);



// WEBPACK FOOTER //
// ./src/containers/labels/translations/LabelTranslationEdit.jsx